export const is2xx = (statusCode: number): boolean => statusCode >= 200 && statusCode <= 299;
export const is4xx = (statusCode: number): boolean => statusCode >= 400 && statusCode <= 499;
export const is5xx = (statusCode: number): boolean => statusCode >= 500 && statusCode <= 599;
